// extracted by mini-css-extract-plugin
export default {"new":"styles_new__YFdgX","btn":"styles_btn__e5P6u","icon":"styles_icon__JiNkd","btnTitle":"styles_btnTitle__+OQWY","options":"styles_options__-hHl8","item":"styles_item__sA3WC"};